import { IonCol, IonGrid, IonRow } from "@ionic/react";
import equal from "deep-equal";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { StringParam, useQueryParams, withDefault } from "use-query-params";

import Select, { Option } from "@components/fields/Select";
import SearchInput from "@components/fieldsNative/SearchInput";
import Form from "@components/forms/Form";

type FormData = {
  categoryId?: string | null;
  search?: string | null;
};

type Props = {
  categoryOptions: Option[];
  filters: FormData;
  onChange: (filterValues: FormData) => void;
};

const MessageTemplateFilters = ({ categoryOptions, filters, onChange }: Props) => {
  const intl = useIntl();

  const [query, setQuery] = useQueryParams({
    categoryId: { ...StringParam, urlName: "messageTemplateCategoryId" },
    categoryName: { ...StringParam, urlName: "messageTemplateCategoryName" },
    search: withDefault({ ...StringParam, urlName: "messageTemplateSearch" }, filters.search)
  });

  const defaultValues: FormData = query;

  const form = useForm<FormData>({
    defaultValues,
    mode: "onChange"
  });

  const categoryId = form.watch("categoryId");
  const search = form.watch("search");

  useEffect(() => {
    const values = { categoryId, search };
    if (!equal(values, filters)) {
      setQuery(values);
      onChange(values);
    }
  }, [filters, onChange, setQuery, search, categoryId]);

  const categoryOptionsWithAny = useMemo(() => {
    const options = [...categoryOptions];

    options.unshift({ label: intl.formatMessage({ id: "dictionary.all" }), value: "" });
    return options;
  }, [categoryOptions, intl]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form hookForm={form} onSubmit={() => {}}>
      <IonGrid>
        <IonRow className="ion-align-items-center">
          <IonCol>
            <Select<FormData>
              control={form.control}
              error={form.formState.errors.categoryId}
              label={intl.formatMessage({ id: "forms.messageTemplateFilters.categoryLabel" })}
              name="categoryId"
              options={categoryOptionsWithAny}
            />
          </IonCol>
          <IonCol>
            <SearchInput
              error={form.formState.errors.search?.message}
              initialValue={defaultValues.search}
              label={intl.formatMessage({ id: "dictionary.search" })}
              name="search"
              setValue={v => form.setValue("search", v)}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </Form>
  );
};

export default MessageTemplateFilters;
